/* eslint-disable no-unused-vars */
import { MIN_COLUMN_WIDTH, MIN_ROW_HEIGHT } from '../../../config'
export const HORIZONTAL = 'horizontal'
export const VERTICAL = 'vertical'


class HelperLine {
  constructor (initParams) {
    const { border, direction } = initParams || {}
    this.direction = direction || VERTICAL
    this.heplerLineVisible = false
    this.dragState = {}
    this.dragging = false
    this.draggingColumn = null
    this.minLeft = 0
    this.minTop = 0
    this.border = border
    this.params = {}
    this.callUpdate = null
    this.targetContainerNode = null
    this.heplerLineNode = null
    this.minDraggingWidth = MIN_COLUMN_WIDTH
    this.minDraggingHeight = MIN_ROW_HEIGHT
    this.handleMouseMove = this.handleMouseMove.bind(this)
    this.handleMouseUp = this.handleMouseUp.bind(this)
    this.target = null
    this.heplerLineNodeAnchor = null
  }
  handleMouseMoveTarget(e, column, tagName = 'DIV', {
    heplerLineNodeAnchor,
    targetNode,
    targetContainerNode
  }) {
    let target = e.target
    this.heplerLineNodeAnchor = heplerLineNodeAnchor
    this.targetContainerNode = targetContainerNode
    // 前置条件
    if (!column || column.resizable === false) { return }
    if (column.children && column.children.length > 0) {
      this.insideTargetElement = false
      return
    }
    // 如果column,存在children。并且children大于0则 跳出。因为children也能拖拽，防止样式污染和逻辑重合
    // 找到内容的 父级中第一个th标签节点。使用该节点作为实际拖拽时的宿主dom。因为列的样式作用于 TH 标签
    while (target && target.tagName !== tagName) {
      target = target.parentNode
    }
    this.target = target
    this.draggingColumn = null
    if (!this.dragging && this.border && target) {
      const rect = target.getBoundingClientRect()
      const { clientX, clientY } = e
      const isVer = this.direction === VERTICAL
      const val = isVer ? (rect.right - clientX <= 3) : (rect.bottom - clientY < 8)
      // right - clientX 是计算相对于视口和当前dom之间差值距离 也就是实际样式的宽度的值
      // right是当前节点距离视口横轴的值。
      // clientX是鼠标在页面视口x坐标值，8是预估的设置样式的临界差值。
      if (val) {
        // 如果存在排序的配置，容器节点也需要设置
        const dragState = this.getDragState(targetNode, e)
        this.visibleHeplerLineNodeAnchor(true)
        const { startLeft, startTop } = dragState || {}
        this.setHeplerLineNodeAnchorStyle({
          left: (startLeft - 4) + 'px',
          top: (startTop - rect.height - 1) + 'px',
          height: rect.height + 'px'
        })
        this.draggingColumn = column
        this.minDraggingWidth = parseInt(column.minWidth) || MIN_COLUMN_WIDTH
        this.minDraggingHeight = parseInt(column.minHeight) || MIN_ROW_HEIGHT
        this.insideTargetElement = true
      } else if (!this.dragging) {
        this.insideTargetElement = false
        this.draggingColumn = null
        this.visibleHeplerLineNodeAnchor(false)
      }
    } else {
      this.insideTargetElement = false
    }
  }
  getTargetContainerNodeRect () {
    const targetContainerNode = this.targetContainerNode
    const { left: targetContainerLeft, top: targetContainerTop } = targetContainerNode.getBoundingClientRect()
    return {
      targetContainerLeft,
      targetContainerTop
    }
  }
  getDragState (targetNode, event) {
    const { height: anchorHeight, width: anchorWidth } = event.target.getBoundingClientRect()
    const { targetContainerLeft, targetContainerTop } = this.getTargetContainerNodeRect()
    const targetRect = targetNode.getBoundingClientRect()
    this.minLeft = targetRect.left - targetContainerLeft + this.minDraggingWidth // 拿公共的最小列宽度配置
    this.minTop = targetRect.top - targetContainerTop + this.minDraggingHeight // 拿公共的最小行高配置
    const dragState = {
      startMouseLeft: event.clientX,
      startMouseTop: event.clientY,
      startLeft: targetRect.right - targetContainerLeft,
      startTop: targetRect.bottom - targetContainerTop,
      startTargetNodeLeft: targetRect.left - targetContainerLeft,
      startTargetNodeTop: targetRect.top - targetContainerTop,
      targetContainerLeft,
      targetContainerTop,
      anchorHeight,
      anchorWidth
    }
    return dragState
  }
  setHelperLineStatus (event, params, callUpdate) {
    if (!this.draggingColumn) {
      return
    }
    const { target, targetNode, heplerLineNode, targetContainerNode } = params
    this.heplerLineNode = heplerLineNode
    this.targetContainerNode = targetContainerNode
    if (target.children && target.children.length > 0) return
    if (this.draggingColumn && this.border) {
      this.callUpdate = callUpdate
      this.dragging = true
      this.params = params
      const dragState = this.getDragState(targetNode, event)
      this.setDargState(dragState)
      this.setHelperLineNodeStyle(this.isVertical() ? dragState.startLeft : dragState.startTop)
      this.visibleHelperLineNode(false)
      this.simulateMoving()
    }
  }
  simulateMoving () {
    document.onselectstart = function () { return false }
    document.ondragstart = function () { return false }
    document.addEventListener('mousemove', this.handleMouseMove)
    document.addEventListener('mouseup', this.handleMouseUp)
  }
  handleMouseMove (event) {
    // 区分水平垂直情况
    const { startLeft, startMouseLeft, anchorWidth } = this.dragState
    const deltaLeft = event.clientX - startMouseLeft
    const proxyLeft = startLeft + deltaLeft

    const left = Math.max(this.minLeft, proxyLeft)
    this.visibleHelperLineNode(true)
    this.setHelperLineNodeStyle(left)

    this.setHeplerLineNodeAnchorStyle({
      left: left - (anchorWidth / 2) + 'px',
    })
    this.visibleHeplerLineNodeAnchor(true)
    if (this.params.handleMouseMove && typeof this.params.handleMouseMove === 'function') {
      this.params.handleMouseMove()
    }
  }

  handleMouseUp (event) {
    event.preventDefault()
    const { target } = this.params
    if (this.dragging) {
      const { startTargetNodeLeft, startTargetNodeTop } = this.dragState
      const dirNum = this.getHelperLineDirNum()
      const finalNum = parseInt(dirNum, 10)
      const val = finalNum - (this.isVertical() ? startTargetNodeLeft : startTargetNodeTop)
      this.callUpdate(this.isVertical() ? Math.max(val, this.minDraggingWidth) : Math.max(val, this.minDraggingHeight), target)
      this.visibleHelperLineNode(false)
      this.visibleHeplerLineNodeAnchor(false)
      this.dragging = false
      this.draggingColumn = null
      this.setDargState({})
      this.heplerLineVisible = false
    }
    document.removeEventListener('mousemove', this.handleMouseMove)
    document.removeEventListener('mouseup', this.handleMouseUp)
    document.onselectstart = null
    document.ondragstart = null
    this.target = null
  }
  setDargState (params = {}) {
    this.dragState = params
  }
  isVertical () {
    return this.direction === VERTICAL
  }
  setHelperLineNodeStyle (move) {
    const dir = this.direction === VERTICAL ? 'left' : 'top'
    const style = this.heplerLineNode.style
    style[dir] = move + 'px'
  }
  visibleHelperLineNode (val) {
    if (this.heplerLineNode) {
      this.heplerLineNode.style.display = val ? 'block' : 'none'
    }
  }
  visibleHeplerLineNodeAnchor (val) {
    if (this.heplerLineNodeAnchor) {
      this.heplerLineNodeAnchor.style.display = val ? 'block' : 'none'
    }
  }
  setHeplerLineNodeAnchorStyle (obj) {
    if (this.heplerLineNodeAnchor) {
      Object.assign(this.heplerLineNodeAnchor.style, obj)
    }
  }
  getHelperLineDirNum () {
    const style = this.heplerLineNode.style
    const dir = this.direction === VERTICAL ? 'left' : 'top'
    const [val = 0] = style[dir].match(/\d+/g) || []
    return +(val)
  }
}

export default HelperLine



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/header/utils/helper-line.js